import { isNil, isEmpty, omit, keys } from 'lodash';
import SCHEMA_REFRESH_STARTER_KITS from 'app/starterkits/SCHEMA_REFRESH_STARTER_KITS';

// The stored schema is a snapshot taken when the integration was created, so fields Roost adds
// later get stripped on upload, download, and deploy. Additive only: overwriting a stored key or
// touching `required` could change how an existing connection deploys.
export default function refreshKitConnectionSchema({ connectionJson, kit, starterkitId }) {
  if (!SCHEMA_REFRESH_STARTER_KITS.includes(starterkitId)) {
    return connectionJson;
  }

  const stored = connectionJson?.connectionTemplate;
  if (isNil(stored)) {
    return connectionJson;
  }

  const current = kit?.connectionJson?.connectionTemplate;
  if (isNil(current)) {
    throw new Error(`Starter kit ${starterkitId} has no connectionTemplate to refresh the stored schema from`);
  }

  const missingProperties = omit(current.properties, keys(stored.properties));
  if (isEmpty(missingProperties)) {
    return connectionJson;
  }

  return {
    ...connectionJson,
    connectionTemplate: {
      ...stored,
      properties: { ...stored.properties, ...missingProperties },
    },
  };
}
